var map = {
	"./osmTagToNameMapping-cs.template.ts": [
		46914,
		6914
	],
	"./osmTagToNameMapping-cs.ts": [
		77344,
		7344
	],
	"./osmTagToNameMapping-de.template.ts": [
		34045,
		4045
	],
	"./osmTagToNameMapping-de.ts": [
		50593,
		593
	],
	"./osmTagToNameMapping-en.ts": [
		94165,
		4165
	],
	"./osmTagToNameMapping-hu.template.ts": [
		94313,
		4313
	],
	"./osmTagToNameMapping-hu.ts": [
		79485,
		9485
	],
	"./osmTagToNameMapping-it.template.ts": [
		24307,
		4307
	],
	"./osmTagToNameMapping-it.ts": [
		29831,
		9831
	],
	"./osmTagToNameMapping-pl.template.ts": [
		16440,
		6440
	],
	"./osmTagToNameMapping-pl.ts": [
		80390,
		390
	],
	"./osmTagToNameMapping-sk.template.ts": [
		59370,
		9370
	],
	"./osmTagToNameMapping-sk.ts": [
		88360,
		8360
	],
	"./osmTagToNameMapping-xx.template.ts": [
		6612,
		6612
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;